<template>
  <header class="main-header">
    <span class="logo-mini">
      <a href="/"><img :src="$store.state.organisationLogo" alt="Logo" class="img-responsive center-block logo"></a>
    </span>
    <nav class="navbar navbar-static-top" role="navigation">
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-lg-3 txt-lg">
              <span>
              {{$store.state.organisationName}} </span>
              <span>(Pan: {{$store.state.organisationPanVatNo}})</span>
              <span>{{$store.state.organisationAddress}}</span>
            </div>
            <div v-if="!this.$store.getters.warehouseId.id > 0" class="p-field p-col-12 p-md-6 p-lg-5 fiscal-drop">
              <span class="txt-lg">Fiscal Year:</span>
              <Dropdown style="margin:-12% -10% 0% 35%"
                  v-model="fyId"
                  :options="fiscalYearLists"
                  optionLabel="name"
                  id="fisaclYear"
                  class="dropDown"
                  :filter="true"
                  placeholder="Select FiscalYear"
                  @change="updateFiscalYear"
                  :showClear="true"
                />
            </div>
            <div class="p-field p-col-12 p-lg-2" style="margin-left: 6%;" v-if="this.$store.getters.warehouseId.id > 0">
              <span>Store:</span>
              <span>{{$store.state.warehouseData.name}}</span>
            </div>
            <div class="p-field p-col-12 p-lg-2" v-if="this.$store.getters.counterId.id > 0">
                <span>Counter:</span>
                <span>{{$store.state.counterData.name}}</span>
            </div>
            <div class="p-field p-col-12 p-md-2 p-lg-2">
              <div class="user-lst">
                <div class="notification-container">
                  <div class="custom-notification-wrapper" @click="toggleNotifications">
                  <i class="pi pi-bell custom-bell-icon"></i>
                  <span v-if="unreadNotificationCount > 0" class="custom-notification-badge">
                    {{ unreadNotificationCount }}
                  </span>
                </div>         
                  <div v-if="showNotifications" class="notification-dropdown">
                    <div class="notification-header">
                      <div class="header-left">
                        <h4>Notifications</h4>
                      </div>
                      <div class="header-right">
                        <div class="p-checkbox p-component" @click="toggleSelectAll">
                          <div class="p-checkbox-box" :class="{'p-highlight': allSelected}">
                            <span class="p-checkbox-icon pi" :class="{'pi-check': allSelected}"></span>
                          </div>
                        </div>                    
                        <Button 
                          v-if="selectedNotifications.length > 0"
                          icon="pi pi-check" 
                          class="p-button-text p-button-rounded p-button-sm"
                          @click="markSelectedAsRead"
                          title="Mark selected as read"
                        />
                      </div>
                    </div>
                    <div class="notification-filter" v-if="hasMultipleTypes">
                      <Dropdown
                        v-model="selectedNotificationType"
                        :options="notificationTypeOptions"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Select type"
                        style="width: 100%; margin-bottom: 8px"
                      />
                    </div>     
                    <div class="notification-list">
                      <div v-if="loadingNotifications" class="chart-loading">
                        <i class="pi pi-spin pi-spinner"></i> Loading notifications...
                      </div>
                      <div v-else-if="displayedNotifications.length === 0" class="no-notifications">
                        No notifications
                      </div>              
                      <div 
                        v-for="notification in displayedNotifications" 
                        :key="getNotificationKey(notification)"
                        :class="[
                          'notification-item',
                          { 
                            'unread': !notification.notified, 
                            'selected': isSelected(notification),
                            'removing': isRemoving(notification),
                            'followup': notification.followUpNotificationDTO,
                            'unpaid': notification.unpaidInvoiceNotificationDTO
                          }
                        ]"
                      >
                        <div class="notification-checkbox" @click.stop="toggleSelection(notification)">
                          <div class="p-checkbox p-component">
                            <div class="p-checkbox-box" :class="{'p-highlight': isSelected(notification)}">
                              <span class="p-checkbox-icon pi" :class="{'pi-check': isSelected(notification)}"></span>
                            </div>
                          </div>
                        </div>        
                        <div class="notification-content" @click="handleNotificationClick(notification)">
                           <h5>
                            {{ getNotificationTitle(notification) }}
                            <span class="notification-type" v-if="notification.followUpNotificationDTO">Follow-up</span>
                            <span class="notification-type unpaid" v-if="notification.unpaidInvoiceNotificationDTO">Unpaid</span>
                          </h5>                                 
                          <p>
                            {{ formatContactNumber(getNotificationContact(notification)) }}
                          </p>
                          <small>
                            {{ getNotificationMessage(notification) }}
                          </small>
                          <div class="notification-time">
                            {{ getNotificationTime(notification) }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="notification-footer" v-if="showViewAllButton">
                      <a href="#" @click.prevent="viewAllNotifications" class="view-all-link">View All Notifications</a>
                    </div>
                  </div>
                </div>
                
                <user-menu :user="user"></user-menu>
              </div>
            </div>
          </div>
        <div class="toast" role="alert" aria-live="assertive" aria-atomic="true"></div>
        <a href="#" class="menu-button sidebar-toggle" data-toggle="offcanvas" role="button"><div class="menu-button-icon"></div></a>
    </nav>
    <audio ref="notifySound" src="static/audio/notification.wav" preload="auto"></audio>
  </header>
</template>

<script>
import UserMenu from './UserMenu'
import Dropdown from 'primevue/dropdown'
import Button from 'primevue/button'

export default {
  name: 'DashHeader',
  props: ['user'],
  data() {
    return {
      fyId: '',
      showNotifications: false,
      loadingNotifications: false,
      notificationPolling: null,
      selectedNotifications: [],
      allSelected: false,
      orgId: null,
      fyIdValue: null,
      removingNotifications: [],
      notificationTypeOptions: [
        { label: 'All', value: 'All' },
        { label: 'Follow-up', value: 'Follow-up' },
        { label: 'Unpaid', value: 'Unpaid' }
      ],
      selectedNotificationType: 'Follow-up'
    }
  },
  created() {
    this.orgId = this.$store.state.organisationid
    this.fyIdValue = this.$store.state.fyId
    const storedFiscalYear = localStorage.getItem('fiscalYear')
    if (storedFiscalYear) {
      if (storedFiscalYear === '[object Object]') {
        localStorage.removeItem('fiscalYear')
        return
      }
      try {
        this.fyId = JSON.parse(storedFiscalYear)
        if (!this.$store.state.fiscalYear.id) {
          this.$store.commit('FISCALYEAR', this.fyId)
        }
      } catch (e) {
        console.error('Error parsing stored fiscal year', e)
        localStorage.removeItem('fiscalYear')
      }
    }
  },
  watch: {
    '$store.state.fiscalYear': {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.id) {
          this.fyId = newVal
        }
      }
    },
    '$store.state.organisationid': {
      immediate: true,
      handler(newVal) {
        this.orgId = newVal
      }
    },
    '$store.state.fyId': {
      immediate: true,
      handler(newVal) {
        this.fyIdValue = newVal
      }
    },
    crmFollowUpNotification(newList, oldList) {
      if (oldList && newList && newList.length > oldList.length) {
        this.playNotificationSound()
      }
    },
    unreadNotificationCount(newVal, oldVal) {
      if (newVal > oldVal) {
        this.playNotificationSound()
      }
    }
  },
  computed: {
    unreadNotificationCount() {
      return this.$store.state.crm.unreadNotificationCount
    },
    fiscalYearLists() {
      return this.$store.state.fiscalYearMaster.fiscalyearLists
    },
    hasUnreadNotifications() {
      return this.unreadNotificationCount > 0
    },
    crmFollowUpNotification() {
      return this.$store.state.crm.crmFollowUpNotification || []
    },
    notificationTypesPresent() {
      const notifications = this.crmFollowUpNotification
      const hasFollowUp = notifications.some(n => n.followUpNotificationDTO)
      const hasUnpaid = notifications.some(n => n.unpaidInvoiceNotificationDTO)
      return { hasFollowUp, hasUnpaid }
    },
    hasMultipleTypes() {
      const { hasFollowUp, hasUnpaid } = this.notificationTypesPresent
      return hasFollowUp && hasUnpaid
    },
    singleType() {
      const { hasFollowUp, hasUnpaid } = this.notificationTypesPresent
      if (hasFollowUp && !hasUnpaid) return 'Follow-up'
      if (!hasFollowUp && hasUnpaid) return 'Unpaid'
      return null
    },
    displayedNotifications() {
      const notifications = this.crmFollowUpNotification
      if (this.singleType) {
        return notifications
          .filter(n => this.singleType === 'Follow-up' ? n.followUpNotificationDTO : n.unpaidInvoiceNotificationDTO)
          .slice(0, 5)
      } else if (this.selectedNotificationType === 'All') {
        return notifications.slice(0, 5)
      } else if (this.selectedNotificationType === 'Follow-up') {
        return notifications.filter(n => n.followUpNotificationDTO).slice(0, 5)
      } else if (this.selectedNotificationType === 'Unpaid') {
        return notifications.filter(n => n.unpaidInvoiceNotificationDTO).slice(0, 5)
      }
      return []
    },
    showViewAllButton() {
      return this.singleType || this.selectedNotificationType !== 'All'
    }
  },
  methods: {
    playNotificationSound() {
      const sound = this.$refs.notifySound
      if (sound) {
        sound.currentTime = 0
        sound.play().catch(err => {
          console.warn('Sound play prevented:', err)
        })
      }
    },
    unlockAudio() {
      const sound = this.$refs.notifySound
      if (sound) {
        sound.play().then(() => {
          sound.pause()
          sound.currentTime = 0
          console.log('Audio unlocked ✔️')
        }).catch(err => {
          console.warn('Autoplay still blocked:', err)
        })
      }
      window.removeEventListener('click', this.unlockAudio)
    },
    getNotificationKey(notification) {
      if (!notification) return null
      if (notification.followUpNotificationDTO) {
        return `followup-${notification.followUpNotificationDTO.followUpId}`
      }
      if (notification.unpaidInvoiceNotificationDTO) {
        return `invoice-${notification.unpaidInvoiceNotificationDTO.id}`
      }
      return Math.random().toString(36).substr(2, 9)
    },
    isRemoving(notification) {
      if (!notification) return false
      const id = this.getNotificationId(notification)
      return this.removingNotifications.includes(id)
    },
    getNotificationId(notification) {
      if (!notification) return null
      if (notification.followUpNotificationDTO) {
        return notification.followUpNotificationDTO.followUpId
      }
      if (notification.unpaidInvoiceNotificationDTO) {
        return notification.unpaidInvoiceNotificationDTO.id
      }
      return null
    },
    getNotificationTitle(notification) {
      if (!notification) return 'Notification'
      if (notification.followUpNotificationDTO) {
        return notification.followUpNotificationDTO.clientName || 'Follow-up'
      }
      if (notification.unpaidInvoiceNotificationDTO) {
        return notification.unpaidInvoiceNotificationDTO.customerName || 'Unpaid Invoice'
      }
      return 'Notification'
    },
    getNotificationContact(notification) {
      if (!notification) return ''
      if (notification.followUpNotificationDTO) {
        return notification.followUpNotificationDTO.contactNumber
      }
      if (notification.unpaidInvoiceNotificationDTO) {
        return notification.unpaidInvoiceNotificationDTO.contactNumber
      }
      return ''
    },
    getNotificationMessage(notification) {
      if (!notification) return ''
      if (notification.followUpNotificationDTO) {
        return notification.followUpNotificationDTO.remark2 || 'No Remarks'
      }
      if (notification.unpaidInvoiceNotificationDTO) {
        const invoice = notification.unpaidInvoiceNotificationDTO
        const dateStr = invoice.chequeDate ? `Cheque Date: ${invoice.chequeDate}` : 'NA'
        const remarksStr = invoice.paymentRemarks ? `Remarks: ${invoice.paymentRemarks}` : 'No Remarks'
        return [dateStr, remarksStr].filter(s => s).join(' | ')
      }
      return ''
    },
    getNotificationTime(notification) {
      if (!notification) return ''
      if (notification.followUpNotificationDTO) {
        return notification.followUpNotificationDTO.followUpTime || ''
      }
      if (notification.unpaidInvoiceNotificationDTO) {
        return notification.unpaidInvoiceNotificationDTO.followUpTime || ''
      }
      return ''
    },
    isSelected(notification) {
      if (!notification) return false
      const id = this.getNotificationId(notification)
      return this.selectedNotifications.includes(id)
    },
    toggleSelection(notification) {
      if (!notification) return
      const id = this.getNotificationId(notification)
      const index = this.selectedNotifications.indexOf(id)
      if (index === -1) {
        this.selectedNotifications.push(id)
      } else {
        this.selectedNotifications.splice(index, 1)
      }
      this.allSelected = this.selectedNotifications.length ===
        this.displayedNotifications.filter(n => n).length
    },
    async handleNotificationClick(notification) {
      if (!notification) return
      const id = this.getNotificationId(notification)
      console.log(id)
      this.removingNotifications.push(id)
      try {
        await this.$store.dispatch('markNotificationAsRead', notification)
        setTimeout(() => {
          this.removingNotifications = this.removingNotifications.filter(i => i !== id)
        }, 300)
        this.navigateToNotification(notification)
      } catch (error) {
        console.error(error)
        this.removingNotifications = this.removingNotifications.filter(i => i !== id)
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to mark notification as read',
          life: 3000
        })
      }
    },
    formatContactNumber(number) {
      if (!number) return ''
      if (typeof number === 'string' && number.includes('E')) {
        try {
          return parseFloat(number).toFixed(0)
        } catch (e) {
          return number
        }
      }
      if (typeof number === 'number' && number.toString().includes('e')) {
        return number.toFixed(0)
      }
      return number
    },
    formatTime(time) {
      if (!time) return ''
      let [hours, minutes] = time.split(':')
      const hour = parseInt(hours)
      const period = hour >= 12 ? 'PM' : 'AM'
      const formattedHour = hour % 12 || 12
      return `${formattedHour}:${minutes} ${period}`
    },
    setupNotificationPolling() {
      this.$store.dispatch('fetchNotifications')
      this.notificationPolling = setInterval(() => {
        const now = new Date()
        const minutes = now.getMinutes()
        const isNearTopOfHour = minutes % 15 < 2
        const interval = isNearTopOfHour ? 3000 : 30000
        clearInterval(this.notificationPolling)
        this.notificationPolling = setInterval(() => {
          this.$store.dispatch('fetchNotifications')
        }, interval)
        this.$store.dispatch('fetchNotifications')
      }, 10000)
    },
    async toggleNotifications() {
      this.showNotifications = !this.showNotifications
      if (this.showNotifications) {
        this.loadingNotifications = true
        try {
          await this.$store.dispatch('fetchNotifications')
        } catch (error) {
          console.error('Error fetching notifications:', error)
        } finally {
          this.loadingNotifications = false
        }
      }
    },
    formatDate(date) {
      if (!date) return ''
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    toggleSelectAll() {
      if (this.allSelected) {
        this.selectedNotifications = []
      } else {
        this.selectedNotifications = this.displayedNotifications.map(notification =>
          notification.followUpNotificationDTO
            ? notification.followUpNotificationDTO.followUpId
            : notification.unpaidInvoiceNotificationDTO.id
        )
      }
      this.allSelected = !this.allSelected
    },
    async markSelectedAsRead() {
      if (this.selectedNotifications.length === 0) return
      try {
        const selectedObjects = this.displayedNotifications.filter(notification =>
          this.selectedNotifications.includes(
            notification.followUpNotificationDTO
              ? notification.followUpNotificationDTO.followUpId
              : notification.unpaidInvoiceNotificationDTO.id
          )
        )
        await this.$store.dispatch('markNotificationsAsRead', selectedObjects)
        this.selectedNotifications = []
        this.allSelected = false
        await this.$store.dispatch('fetchNotifications')
      } catch (error) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Failed to mark notifications as read', life: 3000 })
      }
    },
    navigateToNotification(notification) {
      this.showNotifications = false
      if (notification.followUpNotificationDTO) {
        this.$router.push('/crmTodayFollowUp')
      }
      if (notification.unpaidInvoiceNotificationDTO) {
        this.$router.push('/salesInvoiceTodayUnpaidReport')
      }
    },
    viewAllNotifications() {
      this.showNotifications = false
      const type = this.singleType || this.selectedNotificationType
      if (type === 'Follow-up') {
        this.$router.push('/crmTodayFollowUp')
      } else if (type === 'Unpaid') {
        this.$router.push('/salesInvoiceTodayUnpaidReport')
      }
    },
    async fetchUnreadCount() {
      try {
        if (!this.orgId || !this.fyIdValue) {
          console.warn('Organization ID or Fiscal Year ID not available')
          return
        }
        const count = await this.$store.dispatch('getUnreadNotificationCount')
        this.unreadNotificationCount = count
      } catch (error) {
        console.error('Error fetching unread count:', error)
      }
    },
    async fiscalYearList() {
      await this.$store.dispatch('loadFiscalYearListDropDown')
    },
    async updateFiscalYear() {
      this.$store.commit('FISCALYEAR', this.fyId)
      this.$store.commit('FYID', this.fyId.id)
      let fis = {
        id: this.fyId.id
      }
      try {
        let response = await this.$store.dispatch('loadFiscalYearById', fis)
        this.$store.commit('STARTDATE', response.startDate)
        this.$store.commit('ENDDATE', response.endDate)
        window.localStorage.setItem('fiscalYear', JSON.stringify(this.fyId))
        window.localStorage.setItem('fyId', this.fyId.id)
        window.localStorage.setItem('startDate', response.startDate)
        window.localStorage.setItem('endDate', response.endDate)
        this.$root.$emit('fiscal-year-changed', {
          fiscalYear: this.fyId,
          fyId: this.fyId.id,
          startDate: response.startDate,
          endDate: response.endDate
        })
        this.$toast.add({
          severity: 'success',
          summary: '',
          detail: 'successfully changed fiscal year',
          life: 3000
        })
        this.$store.dispatch('refreshFiscalYearDependentData')
      } catch (error) {
        console.error(error)
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to update fiscal year',
          life: 3000
        })
      }
    },
    setFiscalyear() {
      if (this.$store.state.fiscalYear !== null) {
        if (this.$store.state.fiscalYear.id > 0) {
          this.fyId = this.$store.state.fiscalYear
        }
      }
    },
    cleanupNotificationPolling() {
      if (this.notificationPolling) {
        clearInterval(this.notificationPolling)
        this.notificationPolling = null
      }
    }
  },
  components: {
    UserMenu,
    Dropdown,
    Button
  },
  mounted() {
    window.addEventListener('click', this.unlockAudio)
    window.addEventListener('mousemove', this.unlockAudio, { once: true })
    window.addEventListener('scroll', this.unlockAudio, { once: true })
    this.fiscalYearList()
    this.setFiscalyear()
    this.setupNotificationPolling()
    this.$root.$on('notification-updated', () => {
      this.fetchUnreadCount()
    })
    this.routeGuard = this.$router.beforeEach((to, from, next) => {
      if (to.name === 'crmTodayFollowUp') {
        if (this.$store.state.user && this.$store.state.user.id) {
          next()
        } else {
          next({ name: 'Login' })
        }
      } else {
        next()
      }
    })
  },
  beforeDestroy() {
    this.cleanupNotificationPolling()
    if (this.routeGuard) {
      this.routeGuard()
    }
  }
}
</script>

<style>
.custom-notification-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background: transparent;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-right: 8px;
}

.custom-notification-wrapper:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.custom-bell-icon {
  font-size: 1.8rem !important;
  color: #495057;
  line-height: 1;
}

.custom-notification-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  background: #dc3545;
  color: white;
  border-radius: 50%;
  min-width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: bold;
  border: 2px solid white;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

.notification-dropdown {
  position: absolute;
  right: 0;
  top: calc(100% + 10px);
  width: 400px;
  background: white;
  border-radius: 6px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 10000;
  margin-top: 12px;
  max-height: 500px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid #e9ecef;
}

.notification-header {
  padding: 14px 18px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f8f9fa;
}

.header-left h4 {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
  color: #495057;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.notification-list {
  flex: 1;
  overflow-y: auto;
  max-height: 300px;
  padding: 5px 0;
}

.notification-item {
  padding: 14px 18px;
  border-bottom: 1px solid #f1f1f1;
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  transition: background-color 0.2s;
  border-left: 3px solid transparent;
}

.notification-item:hover {
  background-color: #f8f9fa;
  border-left-color: #2196F3;
}

.notification-item.unread {
  background-color: #f9fbff;
  font-weight: 500;
  border-left-color: #2196F3;
}

.notification-item.selected {
  background-color: #f0f7ff;
}

.notification-checkbox {
  flex: 0 0 26px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-top: 2px;
}

.notification-content {
  flex: 1;
  padding: 2px 0;
}

.notification-content h5 {
  margin: 0 0 6px 0;
  font-size: 15px;
  font-weight: 600;
  color: #212529;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notification-content p {
  margin: 0 0 4px 0;
  font-size: 14px;
  color: #495057;
}

.notification-content small {
  display: block;
  margin: 4px 0;
  color: #6c757d;
  font-size: 13px;
  line-height: 1.4;
  max-height: 42px;
  overflow: hidden;
}

.notification-time {
  font-size: 12px;
  color: #adb5bd;
  margin-top: 4px;
}

.no-notifications {
  padding: 25px;
  text-align: center;
  color: #adb5bd;
  font-style: italic;
  font-size: 14px;
}

.notification-footer {
  padding: 14px 18px;
  border-top: 1px solid #e9ecef;
  text-align: right;
  background: #f8f9fa;
}

.view-all-link {
  color: #2196F3;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: color 0.2s;
}

.view-all-link:hover {
  color: #1976D2;
  text-decoration: underline;
}

.user-lst {
  display: flex;
  align-items: center;
}

.notification-item {
  transition: all 0.2s ease;
  opacity: 1;
}

.notification-item.removing {
  opacity: 0;
  transform: translateY(-10px);
  transition: opacity 0.3s, transform 0.3s;
}
.notification-type {
  font-size: 0.75rem;
  color: #fff;
  background-color: #2196F3;
  padding: 2px 6px;
  border-radius: 4px;
  margin-left: 5px;
}

.notification-type.unpaid {
  background-color: #dc3545;
}
.notification-item.followup {
  border-left-color: #2196F3;
}

.notification-item.unpaid {
  border-left-color: #dc3545;
}

</style>



// WEBPACK FOOTER //
// DashHeader.vue?1e10c6e4